<template>
  <div>
    <div v-if="bookingHasNoShortlistedTalent" class="no-stars">
      <p>
        There are no {{ $t('shortlisted stars') }}.
      </p>
    </div>
    <ul v-else class="shortlist shortlist-horizontal shortlist-col-4">
      <vetting-edit-shortlist-talent
        v-for="(user, index) in bookingShortlistedTalent"
        :key="user.id"
        :user="user"
        :index="index"/>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { helpers } from 'mixins/bookings'
import VettingEditShortlistTalent from './VettingEditShortlistTalent'

export default {
  mixins: [helpers],

  components: {
    VettingEditShortlistTalent
  },

  computed: mapState('booking/request/vetting', { booking: 'request' })
}
</script>
